<template>
	<span v-if="$slots.default" class="c-state" :tag="tag" :style="compStyle"><slot></slot></span>
	<span v-else-if="type == 'expectedDate'" v-show="value" class="c-state" :tag="tag" :style="compStyle">
		<span v-if="value <= -1">剩余{{Math.floor(Math.abs(value))}}天</span>
		<span v-else-if="value < 0">剩余&lt;1天</span>
		<span v-else-if="value < 1">逾期&lt;1天</span>
		<span v-else>逾期{{Math.floor(value)}}天</span>
	</span>
	<span v-else-if="data" v-show="data.name" class="c-state" :tag="tag" :style="compStyle">{{data.name}}</span>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		name: 'cState',
		
		props: {
			type: String,
			dict: String,
			async: Boolean,
			value: [Number, String],
			tag: Boolean,
			color: String
		},
		
		data() {
			return {
				colorDict: {
					gray: '#999999',
					blue: '#0D6EFE',
					red: '#FF0000',
					green: '#2EBC78',
					yellow: '#FFAE00',
					orange: '#FF5400'
				}
			}
		},
		
		computed: {
			...mapState(['dictData', 'asyncDictData']),
			
			compDictData() {
				if (this.async) {
					return this.asyncDictData[this.dict];
				} else {
					return this.dictData[this.dict];
				}
			},
			
			data() {
				return this.compDictData ? this.compDictData[this.value] : {name: this.value};
			},

			compStyle() {
				if (this.type == 'expectedDate') {
					return {
						color: '#fff',
						[this.tag ? 'background' : 'color']: this.colorDict[
							this.value <= -1 ? 'green' :
								this.value < 0 ? 'orange' : 'red'
						]
					}
				}

				return {
					color: '#fff',
					[this.tag ? 'background' : 'color']: this.color || this.colorDict[this.data.color] || this.data.color
				}
			}
		},
		
		created() {
			if (this.async && this.dict && !this.compDictData) {
				this.$store.dispatch('getAsyncDict', this.dict);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-state {
		&[tag] {
			padding: 2px 5px;
			border-radius: 4px;
			line-height: normal;
		}	
	}
</style>